/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { utils as commonUtils } from '../../common/utils';
import Auth from './Auth';
import PromiseAbortController from './PromiseAbortController';
import { onConsentReady } from './consentGate';
import { isRedirectSuppressed, setRedirectSuppressed } from './redirectCookie';
import refreshAds from './refreshAds';
import safelyEvalAdScript from './safelyEvalAdScript';

export const utils = {
	...commonUtils,
	Auth,
	PromiseAbortController,
	onConsentReady,
	isRedirectSuppressed,
	setRedirectSuppressed,
	refreshAds,
	safelyEvalAdScript,
};
